// extracted by mini-css-extract-plugin
export default {"buttonCard":"UpButton_buttonCard__hAJFb","buttonCardVisible":"UpButton_buttonCardVisible__bFwpl","button":"UpButton_button__8+OoT","image":"UpButton_image__ib3mO"};